/* Native Shopify customer forms: no AJAX, synthetic success or subscriber data storage. */
(function(){
  'use strict';

  var pendingKey = 'nowar-newsletter-pending';
  var dismissedKey = 'nowar-newsletter-dismissed';
  var dismissedUntilKey = 'nowar-newsletter-dismissed-until';
  var signedUpKey = 'nowar-newsletter-signed-up';
  var popupCooldownMs = 30 * 24 * 60 * 60 * 1000;
  var popupController = null;

  function wasDismissed(){
    try {
      if (Number(window.localStorage.getItem(dismissedUntilKey)) > Date.now()) return true;
    } catch(e) { /* Session storage can still remember this visit. */ }
    try { return window.sessionStorage.getItem(dismissedKey) === '1'; }
    catch(e) { return false; }
  }

  function rememberPopupVisit(){
    try { window.sessionStorage.setItem(dismissedKey, '1'); }
    catch(e) { /* Optional preference only. */ }
    try { window.localStorage.setItem(dismissedUntilKey, String(Date.now() + popupCooldownMs)); }
    catch(e) { /* Native signup and manual opening still work. */ }
  }

  function signedUpOnThisBrowser(){
    try { return window.localStorage.getItem(signedUpKey) === '1'; }
    catch(e) { return false; }
  }

  function rememberSignup(){
    try { window.localStorage.setItem(signedUpKey, '1'); }
    catch(e) { /* Native signup still works when storage is unavailable. */ }
  }

  function pendingFormId(){
    var anchor = window.location.hash.slice(1);
    var anchoredForm = document.getElementById(anchor);
    if (anchoredForm && anchoredForm.matches('[data-newsletter-form]')) return anchor;
    try {
      var pending = JSON.parse(window.sessionStorage.getItem(pendingKey));
      if (pending && Date.now() - pending.at < 30 * 60 * 1000) return pending.id;
    } catch(e) { /* Storage is optional; the native form anchor still works. */ }
    return null;
  }

  function initialiseForms(){
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-newsletter-form]'));
    var sourceId = pendingFormId();
    var hasResponse = false;
    forms.forEach(function(form){
      if (form.dataset.newsletterReady) return;
      form.dataset.newsletterReady = 'true';
      var state = form.querySelector('[data-newsletter-state]');
      var fields = form.querySelector('[data-newsletter-fields]');
      var success = form.querySelector('[data-newsletter-success]');
      var error = form.querySelector('[data-newsletter-error]');
      var status = form.querySelector('[data-newsletter-status]');
      var email = form.querySelector('input[type="email"]');
      var button = form.querySelector('[data-newsletter-submit]');
      var label = button.textContent;
      var submitting = false;
      var timer = null;

      // Shopify can expose the same customer-form response to both forms.
      // An origin marker selects the form; it never establishes success.
      if (sourceId && form.id !== sourceId) {
        state.dataset.newsletterState = 'idle';
        fields.hidden = false;
        success.hidden = true;
        error.hidden = true;
        email.value = '';
        email.removeAttribute('aria-invalid');
        email.removeAttribute('aria-describedby');
      }
      if (state.dataset.newsletterState !== 'idle') {
        hasResponse = true;
        if (state.dataset.newsletterState === 'success') rememberSignup();
        if (form.id !== 'nl-form') {
          window.requestAnimationFrame(function(){
            (state.dataset.newsletterState === 'success' ? success : error).focus();
          });
        }
      }

      function resetBusy(){
        window.clearTimeout(timer);
        submitting = false;
        form.removeAttribute('aria-busy');
        button.disabled = false;
        button.textContent = label;
        status.textContent = '';
      }

      form.addEventListener('submit', function(event){
        if (submitting) { event.preventDefault(); return; }
        if (!form.reportValidity()) { event.preventDefault(); return; }
        submitting = true;
        try {
          // Store only the originating form ID and time, never the email or consent.
          window.sessionStorage.setItem(pendingKey, JSON.stringify({id: form.id, at: Date.now()}));
        } catch(e) { /* Native POST does not depend on storage. */ }
        // Leave Shopify's native redirect intact so Liquid receives its result.
        // A custom return_to can discard posted_successfully? after a valid signup.
        // Wait for Shopify's captcha listeners; never interfere with a challenge.
        window.setTimeout(function(){
          if (event.defaultPrevented) { resetBusy(); return; }
          form.setAttribute('aria-busy', 'true');
          button.disabled = true;
          button.textContent = status.dataset.loadingText;
          error.hidden = true;
          status.textContent = status.dataset.loadingText;
          timer = window.setTimeout(function(){
            resetBusy();
            status.textContent = status.dataset.timeoutText;
          }, 20000);
        }, 0);
      });
      // Browsers can restore disabled buttons when returning with Back.
      window.addEventListener('pageshow', resetBusy);
    });
    if (hasResponse) {
      try { window.sessionStorage.removeItem(pendingKey); } catch(e) { /* Optional UI state. */ }
    }
  }

  function initialisePopup(){
    var modal = document.getElementById('nl-modal');
    var opener = document.getElementById('nl-fab');
    if (!modal || !opener || modal.dataset.newsletterReady) return;
    if (popupController) popupController.destroy();
    modal.dataset.newsletterReady = 'true';
    var previousFocus = null;
    var previousOverflow = '';
    var autoTimer = null;
    var delayPassed = false;
    var state = modal.querySelector('[data-newsletter-state]');
    var intro = modal.querySelector('[data-newsletter-intro]');
    var succeeded = state && state.dataset.newsletterState === 'success';
    var knownSubscriber = modal.dataset.customerSubscribed === 'true';
    if (intro) intro.hidden = succeeded;
    modal.setAttribute('aria-labelledby', succeeded ? 'nl-form-success-title' : 'nl-modal-title');

    function focusResult(){
      var target = modal.querySelector(succeeded ? '[data-newsletter-success]' : '[data-newsletter-error]:not([hidden])');
      if (!target) target = modal.querySelector('input[type="email"]');
      if (target) target.focus();
    }
    function open(){
      window.clearTimeout(autoTimer);
      window.removeEventListener('scroll', autoOpen);
      if (modal.classList.contains('open')) return;
      previousFocus = document.activeElement === document.body ? opener : document.activeElement;
      previousOverflow = document.body.style.overflow;
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(focusResult);
    }
    function close(rememberDismissal){
      if (!modal.classList.contains('open')) return;
      if (rememberDismissal !== false) rememberPopupVisit();
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow;
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    }
    function onKeydown(event){
      if (!modal.classList.contains('open')) return;
      // Shopify can put a captcha challenge in a separate iframe above the dialog.
      if (isCaptchaFrame(document.activeElement)) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      var stops = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]), input:not([type="hidden"]):not([disabled]), a[href], [tabindex="0"]'))
        .filter(function(element){ return element.getClientRects().length > 0; });
      var first = stops[0];
      var last = stops[stops.length - 1];
      if (!first) return;
      var active = document.activeElement;
      if (event.shiftKey && (active === first || stops.indexOf(active) === -1)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (active === last || stops.indexOf(active) === -1)) {
        event.preventDefault(); first.focus();
      }
    }
    function onFocus(event){
      if (modal.classList.contains('open') && !modal.contains(event.target) && !isCaptchaFrame(event.target)) focusResult();
    }
    function isCaptchaFrame(element){
      return element && element.tagName === 'IFRAME' && /hcaptcha\.com|recaptcha/i.test(element.getAttribute('src') || '');
    }
    function autoOpen(){
      if (!delayPassed || window.scrollY < window.innerHeight || !modal.isConnected || modal.classList.contains('open') || wasDismissed() || knownSubscriber || signedUpOnThisBrowser()) return;
      if (document.querySelector('.cart-drawer.open, .drawer.open, .size-guide-modal.open, [data-size-dialog].open, #size-guide.open, .pdp-info-modal.open, #shopify-pc__banner, .shopify-pc__banner, [data-testid="privacy-banner"]')) {
        window.clearTimeout(autoTimer);
        autoTimer = window.setTimeout(autoOpen, 2000);
        return;
      }
      rememberPopupVisit();
      open();
    }
    opener.addEventListener('click', open);
    modal.querySelectorAll('[data-nl-close]').forEach(function(element){ element.addEventListener('click', close); });
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('focusin', onFocus);
    popupController = {destroy: function(){
      window.clearTimeout(autoTimer);
      close(false);
      window.removeEventListener('scroll', autoOpen);
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('focusin', onFocus);
    }};
    if (state && state.dataset.newsletterState !== 'idle') open();
    else if (modal.dataset.autoOpen === 'true' && modal.dataset.autoEligible === 'true' && !wasDismissed() && !knownSubscriber && !signedUpOnThisBrowser() && !document.querySelector('[data-newsletter-state="success"], [data-newsletter-state="error"]')) {
      window.addEventListener('scroll', autoOpen, {passive: true});
      autoTimer = window.setTimeout(function(){ delayPassed = true; autoOpen(); }, Number(modal.dataset.delayMs) || 30000);
    }
  }

  function initialise(){ initialiseForms(); initialisePopup(); }
  initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', function(event){
    if (popupController && event.target.querySelector('#nl-modal')) {
      popupController.destroy();
      popupController = null;
    }
  });
})();
